import { APIService } from '../api';
import { AuthService } from '../auth';
import { ChatMessage } from './ChatMessage';
import { Model } from './Model';
import { HasMany, HasOne, Relations } from './Relations';
import { User } from './User';

export class ChatRoom extends Model implements Relations<ChatRoom> {
    public readonly blueprint = ChatRoom;
    public readonly endpoint = APIService.createLambdaEndpoint('chat/rooms/{room_id}');
    public typing_members: any[];

    public relations() {
        return [
            HasOne('initiator', User, ChatRoom),
            HasMany('members', User, ChatRoom),
            HasOne('last_message', ChatMessage, ChatRoom),
        ];
    }

    public total_messages!: number;
    public unread_messages!: number;
    public initiator_id!: number;
    public platform!: string;
    public new!: boolean;

    public initiator!: User;
    public members!: User[];
    public last_message!: ChatMessage;

    public lastMessage(): string | null {
        return this.last_message?.message || null;
    }

    public getMembers(): string[] {
        return (this.members || [])
            .filter((member) => member.id !== AuthService.getInstance().getLoggedUser()?.id)
            .map((member) => member.$fullName());
    }
}
